import type { ReactNode } from 'react';
import Container from '@/components/base/Container';
import Eyebrow from '@/components/base/Eyebrow';
import TitleReveal from '@/components/base/TitleReveal';

interface PageIntroProps {
  eyebrow: string;
  title: string;
  children?: ReactNode;
}

export default function PageIntro({ eyebrow, title, children }: PageIntroProps) {
  return (
    <section className="bg-background-50 pt-14 md:pt-24 pb-12 md:pb-16">
      <Container>
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2 lg:gap-16">
          <Eyebrow label={eyebrow} />
          <div>
            <TitleReveal key={title} as="h1" className="text-[38px] md:text-[56px] lg:text-[64px] font-medium leading-[1.02] tracking-[-0.03em] text-foreground-950">{title}</TitleReveal>
            {children && <div className="mt-6 max-w-md text-[15px] md:text-base leading-relaxed text-foreground-600">{children}</div>}
          </div>
        </div>
      </Container>
    </section>
  );
}